import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import BudgetsAppReducer from './app-budgets';
import LoyaltyAppReducer from './app-loyalty';
import BusinessAppReducer from './app-business';
import AuthReducer from './AuthReducer';
import MetaReducer from './MetaReducer';
import ConfirmReducer from './ConfirmReducer';
import LoadingReducer from './LoadingReducer';
import DashboardUsersReducer from './DashboardUsersReducer';
import AppReducer from './AppReducer';
import EditorReducer from './EditorReducer';
import { LOGOUT, VERIFICATION_FAILED, CLEAR_COMPANY, CLEAR_RESTAURANT, CLEAR_LOYALTY_PROGRAM } from '../actions/types';

const rootReducer = combineReducers({
    app: AppReducer,
    meta: MetaReducer,
    confirm: ConfirmReducer,
    loading: LoadingReducer,
    toastr: toastrReducer,
    editor: EditorReducer,
    auth: AuthReducer,    
    dashboardUsers: DashboardUsersReducer,
    businessApp: BusinessAppReducer,
    budgetsApp: BudgetsAppReducer,
    loyaltyApp: LoyaltyAppReducer,
});

export default (state, action) => {
    switch (action.type) {
        case CLEAR_COMPANY:
            return rootReducer({ ...state, budgetsApp: undefined }, action);
        case CLEAR_RESTAURANT:
            return rootReducer({ ...state, restaurant: undefined }, action);
        case CLEAR_LOYALTY_PROGRAM:
            return rootReducer({ ...state, loyaltyApp: undefined }, action);
        case LOGOUT:
        case VERIFICATION_FAILED:
            return rootReducer({
                locale: state.locale,
                toastr: state.toastr,
                loading: state.loading,
                auth: state.auth,
            }, action);
        default:
            return rootReducer(state, action);
    }
};
